export default __webpack_public_path__ + "static/banner-whats-your-interior-design-style-a104f55941609cb8bcd38be40313d8ff.jpg";